<style lang="scss" src='./ComingSoon.scss' scoped></style>
<template src="./ComingSoon.html"></template>

<script>

export default {
  name: 'ComingSoon',
  data() {
    return ({
    });
  },
  computed: {},

  methods: {},

  beforeCreate() {},

  created() {},

  mounted() {},
};
</script>
